

import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {PortalAvukatTalepTebligatTuruListCevapRow} from "@/plugins/uyap-plugin/uyap/PortalAvukatTalepTebligatTuruList";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import SehirPicker from "@/components/pickers/SehirPicker.vue";
import {ihbarname89_1ZorunluTebligatTuru} from "@/plugins/uyap-plugin/utils/tebligatTalepUtils";

@Component({
  components: {SehirPicker}
})

export default class AvukatTalepTebligatTuruPicker extends Mixins(SimpleInputMixin) {
  @Prop() rules!: string;
  @Prop() showUyapIcon!: string | boolean;
  @Prop() tooltip!: string;
  /**
   * Yalnız 89/1 ihbarnamesinde verilir: seçili adres türü. UYAP portalı 89/1'de E-Tebligat
   * adresine yalnızca "E-Tebligat (Dönüşlü)" sunuyor (DEV-3687); liste ona daraltılır ve o tür
   * kendiliğinden seçilir. Diğer adres türlerinde tam liste gösterilir.
   */
  @Prop() ihbarname891AdresTuru!: number | string | null;

  items: Array<PortalAvukatTalepTebligatTuruListCevapRow> = [];

  get isShowUyapIcon() {
    return this.showUyapIcon || this.showUyapIcon === "";
  }

  get zorunluTur(): PortalAvukatTalepTebligatTuruListCevapRow | null {
    if (this.ihbarname891AdresTuru === undefined || this.items.length == 0)
      return null;
    try {
      return ihbarname89_1ZorunluTebligatTuru(this.items, this.ihbarname891AdresTuru);
    } catch (e) {
      // Listede dönüşlü e-tebligat yoksa tam liste gösterilir; gönderim adımı anlaşılır hata verir.
      return null;
    }
  }

  get gorunenItems(): Array<PortalAvukatTalepTebligatTuruListCevapRow> {
    const zorunlu = this.zorunluTur;
    return zorunlu ? this.items.filter(item => item.postaMasraflariId == zorunlu.postaMasraflariId) : this.items;
  }

  onTebligatTuruChange(v: PortalAvukatTalepTebligatTuruListCevapRow) {
    this.$emit('tebligatTuruAciklama', (this.items.find((item) => (item.postaMasraflariId == this.localValue)))?.masrafAdi);
    this.input();
  }

  @Watch('zorunluTur')
  onZorunluTurChange(zorunlu: PortalAvukatTalepTebligatTuruListCevapRow | null, onceki: PortalAvukatTalepTebligatTuruListCevapRow | null) {
    if (zorunlu && this.localValue !== zorunlu.postaMasraflariId) {
      this.localValue = zorunlu.postaMasraflariId;
      this.onTebligatTuruChange(zorunlu);
    } else if (!zorunlu && onceki && this.localValue === onceki.postaMasraflariId) {
      // Adres türü E-Tebligat'tan başka bir türe geçti: kendiliğinden seçilen tür o adrese
      // uymayabilir, kullanıcı yeniden seçsin.
      this.localValue = null;
      this.$emit('tebligatTuruAciklama', "");
      this.input();
    }
  }

  created() {
    this.load();
  }

  async load() {
    this.items = (await this.$uyap.PortalAvukatTalepTebligatTuruList().run({}));
  }
}
